import React, { createContext, useCallback, useContext, useState, PropsWithChildren } from "react";
import { Environment } from '../../../environment/app-settings'

import {AppSnackbar} from "./AppSnackbar"
import {APP_SNACKBAR_VARIANT } from "./AppSnackbarProps"


type AppSnackbarContextValue = { showSnackbar: (message: string, variant?: APP_SNACKBAR_VARIANT, durationMs?: number) => void }
const AppSnackbarContext = createContext<AppSnackbarContextValue | undefined>(undefined)


export const useAppSnackbar = (): AppSnackbarContextValue => {
    const ctx = useContext(AppSnackbarContext)
    if (!ctx) {
        throw new Error("Brak AppSnackbarProvider")
    }
    return ctx
}

export const AppSnackbarProvider = (props: PropsWithChildren<any>) => {
    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState("")
    const [variant, setVariant] = useState<APP_SNACKBAR_VARIANT>(APP_SNACKBAR_VARIANT.INFO)
    const [duration, setDuration] = useState<number>(Environment.DEFAULT_SNACKBAR_AUTO_HIDE_DURATION_IN_MS)


    const hide = useCallback(() => {
        setOpen(false)
        setMessage("")
    }, [])


    const showSnackbar = useCallback(
        (msg: string, variant: APP_SNACKBAR_VARIANT = APP_SNACKBAR_VARIANT.INFO, durationMs: number = Environment.DEFAULT_SNACKBAR_AUTO_HIDE_DURATION_IN_MS) => {
            setMessage(msg)
            setVariant(variant)
            setDuration(durationMs)
            setOpen(true)
        }, []
    )


    return (
        <AppSnackbarContext.Provider value={{ showSnackbar }}>
            {props.children}
            <AppSnackbar open={open} message={message} variant={variant} onClose={hide} duration={duration} />
        </AppSnackbarContext.Provider>
    )
}